module.exports = __webpack_public_path__ + "img/page3-4.2c199788.png";